<template>
  <div class="ag-page-title-block">
    <div
      class="title-block padding-l-vertical l:padding-2xl-vertical padding-2xl-horizontal border-radius flex-middle flex-center"
      :class="`bg-${theme}`">

      <div class="main-title flex margin-auto flex-middle flex-center">
        <h1 class="margin-m-bottom l:margin-remove c-bg-1"
        :class="`c-${textTheme}`">
          <slot>{{ tt(text) }}</slot>
        </h1>
      </div>
    </div>
    <div class="block-tools" v-if="$slots['tools']">
      <div
        class="flex-center margin-auto-inline gap-s l:gap-xl margin-xl-bottom"
        style="width: 90%; max-width: 700px; transform: translateY(-50%)">
      <slot name="tools"></slot>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: false,
    },
    theme: {
      type: [String],
      default: "lead-1",
    },
    textTheme: {
      type: [String],
      default: "bg-1",
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
.main-title h1 {
  font-size: calc(var(--font-max) * 2);
  line-height: calc(var(--font-max) * 1.65);

  @media (max-width: 767px) {
    font-size: calc(var(--font-max));
    line-height: calc(var(--font-max) * 1);
  }
}
</style>
